import Service from "@services/Service";
import { WEB_API_ENDPOINT } from "@utils/awsAmplify";

class Account extends Service {
  static getAccountDetail() {
    return Account.get(WEB_API_ENDPOINT, "/account_details");
  }
}

export default Account;
